module.exports = __webpack_public_path__ + "static/media/defaultCard.8ed1f8d5.svg";